export default __webpack_public_path__ + "1b0b69ae4c9d3d3c30aa2ba3a212b0a1.png";